<template>
  <div>
    <a-card>
      <g-master name="forms"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="parentData"
                :actions="master.actions"
                :beforeSend="master.beforeSend"
                ref="master"
                @action="masterAction"
                modalWidth="80%"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-lookup :label="$t('Responsable')"
                        :formItemConfig="fiOptions"
                        endpoint="empleados"
                        ref="empleado"
                        :decorator="['responsable', { rules: [{ required: true, message: 'Valor requerido' }] }]"
              >
              </g-lookup>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Fecha')">
                <a-date-picker style="width: 100%"
                               valueFormat="Y-MM-DD HH:mm:ss"
                               v-decorator="['date_tracing', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                ></a-date-picker>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Descripción')">
                <a-textarea style="width: 100%"
                            autoSize
                            v-decorator="['description', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-card>
  </div>
</template>
<script>
  import JsUtils from '../../../../util/JsUtils'

  export default {
    data () {
      return {
        id_h_origin: {
          h_lookup_type: 'INCAPACIDADES_ORIGEN'
        },
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 12},
        master: {
          actions: [
            {
              name: 'masterCreate',
              text: 'Crear',
              permisos: [],
              props: {icon: 'plus', type: 'button'},
              fnVisible: (record) => {
                return this.$userIsInrol('SST-Director') || this.$userIsInrol('SST-Auxiliar')
              }
            }],
          beforeSend: (data) => {
            data.type = 'JUR'
            return data
          },
          endpoint: 'absen_sst_tracing',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    return this.$userIsInrol('SST-Auxiliar')
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    return this.$userIsInrol('SST-Director')
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Responsable', dataIndex: 'responsable', sorter: true},
              {title: 'Nombre', dataIndex: 'nombre_empleado', sorter: true},
              {title: 'Fecha', dataIndex: 'fecha', sorter: true},
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          }
        }
      }
    },
    props: ['abs_id'],
    computed: {
      parentData () {
        return {
          abs_id: this.abs_id,
          type: 'JUR'
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            if (!JsUtils.isEmpty(action.record.responsable)) {
              this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.responsable)
            }
            break
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/MatrizSeguimiento/SeguimientoJuridico.vue